<template>
    <div class="app-container">
        <div class="filter-container">
            <el-form :model="query" :inline="true" size="small" label-width="180px">
                <el-form-item>
                    <el-input
                        clearable
                        v-model="query.userIdOrEmail"
                        :placeholder='"ID/" +  $i18n.t("common.LoginEmail")'
                        style="width: 180px"
                        class="filter-item"
                        @keyup.enter.native="handleQuery"
                        oninput="value=value.replace(/[%]/g,'')"
                    />
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="query.countryCodes"
                        :multiple="true"
                        :placeholder='$i18n.t("common.country")'
                        style="width: 180px; margin-left: 10px"
                        class="filter-item"
                    >
                        <el-option
                            v-for="cc in countrysDicts"
                            :key="cc.code"
                            :label="cc.name + '(' + cc.code + ')'"
                            :value="cc.code"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                        <el-date-picker
                            v-model="vipPicker"
                            type="daterange"
                            :range-separator="$i18n.t('common.to')"
                            :start-placeholder="$i18n.t('common.Addtime')"
                            :end-placeholder="$i18n.t('common.Addtime')"
                            format="yyyy-MM-dd"
                            :default-time="['00:00:00', '23:59:59']"
                        />
                    </el-form-item>
                <el-form-item>
                    <el-button class="filter-item" icon="el-icon-search" type="primary" @click="handleQuery" style="margin-left: 10px">
                        {{ $i18n.t("common.query") }}
                    </el-button>
                    <el-button
                        class="filter-item"
                        icon="el-icon-search"
                        type="primary"
                        @click="cleanQuery"
                        style="margin-left: 10px"
                        size="small"
                    >  {{ $i18n.t("common.Reset") }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table v-loading="listLoading" :data="list.list" border stripe style="width: 100%; margin-top: 20px">
            <el-table-column :label='$i18n.t("common.UserID")' prop="userId" align="center" width="100px"> </el-table-column>
            <el-table-column :label='$i18n.t("common.country")'  prop="countryCode" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
				    <div>{{$dict.getDictValue('countrys',scope.row.countryCode)}}</div>
				</template>	
            </el-table-column>
            <el-table-column :label='$i18n.t("common.mailbox")' prop="email" align="center" show-overflow-tooltip> </el-table-column>
            <el-table-column :label='$i18n.t("common.reason")' prop="reason" align="center" show-overflow-tooltip> </el-table-column>
            <el-table-column :label='$i18n.t("common.Addtime")' prop="createTime" align="center" show-overflow-tooltip :formatter="formatDate"></el-table-column>
            <el-table-column :label='$i18n.t("common.Operator")' prop="updateByName" align="center" show-overflow-tooltip> </el-table-column>
            <el-table-column :label='$i18n.t("common.OperatingTime")' prop="updateTime" align="center" show-overflow-tooltip :formatter="formatDate"></el-table-column>
            
            <el-table-column :label='$i18n.t("common.operation")' align="center" show-overflow-tooltip>
                <template slot-scope="{ row }">
                    <el-button type="text" size="mini" @click="handleDeleteSingle(row)" class="table-inner-button">  {{ $i18n.t("common.RemoveFromBlacklist") }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="block">
            <el-pagination
                style="margin-top: 10px"
                background
                @current-change="handleCurrentChange"
                :current-page="query.page"
                :page-size="query.size"
                layout="total, prev, pager, next, jumper"
                :total="list.total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import dataSelect from '@/components/common/DataSelect.vue';
import dataText from '@/components/common/DataText.vue';
import Pagination from '@/components/common/Pagination/';
import moment from 'moment';
import X2JS from 'x2js'; //解析xml

function initAddBean() {
    const addBean = {
        areaId: null,
        countryCode: null,
        postCode: null
    };
    return addBean;
}

export default {
    name: 'UserBlack',
    components: {
        dataSelect,
        dataText,
        Pagination,
        moment,
    },
    data() {
        var checkDateTime = (rule, value, callback) => {
            if (this.valuePicker.length > 0) {
                callback();
            } else {
                callback(new Error( this.$i18n.t("common.Pleaseselectatimerange")));
            }
        };
        var isTrue = (rule, value, callback) => {
            var pattern = /^(([\*])|(\w{1,8}[\*]?))$/;
            if (!pattern.test(value)) {
                return callback(new Error(this.$i18n.t("common.Pleaseenterthepostalcodecorrectly")));
            } else {
                return callback();
            }
        };
        return {
            formTitle: '',
            old: initAddBean(),
            addRestricted: initAddBean(),
            list: [],
            total: 0,
            listLoading: false,
            countrysDicts: [],
            brandDicts: [],
            vipPicker:[],
            query: {
                page: 1,
                limit: 10,
                userIdOrEmail: null,
                countryCodes:[],
                beginTime:null,
                endTime: null
            },
            ossHost: process.env.VUE_APP_OSS_Head,
            ossSignature: { host: '' },
            addVisible: false,

            countryLang: [],
            //字典取的语言
            langs: [],
            formRules: {
                postCode: [
                    { required: true, message: this.$i18n.t("common.Pleasefillinthepostalcode"), trigger: 'blur' },
                    { validator: isTrue, trigger: 'blur'}
                ],
                countryCode: [
                    { required: true, message: this.$i18n.t("common.Pleaseselectacountry"), trigger: 'change' }
                ]
            }
        };
    },
    created() {
        this.doQueryList({ page: 1 });
        this.getDictItems();
    },
    mounted() {
        this.getOssSignature();
        this.getDictItems();
        this.getLangDictItems();
    },
    methods: {
        /**
         * 分页
         */
        handleCurrentChange(val) {
            this.query.page = val;
            this.doQueryList({ page: val });
        },
        closeForm() {
            this.addVisible = false;
            this.doQueryList({ page: 1 });
        },
        /**
         * 时间戳转码
         */
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property];
            if (!data) {
                return '';
            } else {
                return moment(data).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        /**
         * 触发搜索操作
         */
        handleQuery() {
            this.doQueryList({ page: 1 });
        },
        /**
         * 执行列表查询
         */
        doQueryList({ page, limit }) {
            this.listLoading = true;
            if (page) {
                this.query.page = page;
            }
            if (limit) {
                this.query.limit = limit;
            }

            this.$store.dispatch('getUserBlackList', this.query).then((res) => {
                this.list = res;
            }).finally(() => {
                this.listLoading = false;
            });
        },
        /**
         * 删除单条记录
         */
        handleDeleteSingle(row) {
            this.$confirm( this.$i18n.t("common.RemoveBlacklist"),   this.$i18n.t("common.prompt"), {
                // confirmButtonText: '确定',
                // cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$store.dispatch('deleteUserBlack', { id: row.userBlackId }).then((res) => {
                        this.doQueryList({ page: 1 });
                        this.$message({
                            message:   this.$i18n.t("common.Successfullydeleted"),
                            type: 'success'
                        });
                    });
                })
                .catch(() => {});
        },
        getOssSignature() {
            var _this = this;
            this.$store.dispatch('getSignature', { dir: 'b2c' }).then((res) => {
                _this.ossSignature = res;
                _this.ossSignature.host = _this.ossHost;
            });
        },

        getDictItems() {
            var _this = this;
            this.$store.dispatch('getDicItems', { tag: 'brand' }).then((res) => {
                if (res != null) _this.brandDicts = res;
            });
            this.$store.dispatch('getDicItems', { tag: 'countrys' }).then((res) => {
                if (res != null) _this.countrysDicts = res;
            });
            this.$store.dispatch('getDicItems', { tag: 'countrylang' }).then((res) => {
                if (res != null) _this.countryLang = res;
            });
        },
        getLangDictItems() {
            var _this = this;
            this.$store.dispatch('getDicItems', { tag: 'lang' }).then((res) => {
                _this.langs = res;
            });
        },
        cleanQuery() {
            this.query.userIdOrEmail = null;
            this.query.countryCodes = [];
            this.query.beginTime = null;
            this.query.endTime = null;
            this.vipPicker = [];
            this.doQueryList({ page: 1 });
        }
    }
};
</script>
<style scoped>
.filter-container {
    padding: auto;
    margin-left: 20px;
    padding-top: 20px;
}
</style>
